import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

type SortableItemProps = React.HTMLAttributes<HTMLDivElement> & {
  id: string;
};

export const SortableItem = ({ id, children }: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style: React.CSSProperties = {
    // Note: we only support vertical sorting, no need to use x-axis transformation, only y-axis is needed
    transform: isDragging ? `translate3d(0px, ${transform?.y ?? 0}px, 0) scale(1.01)` : CSS.Transform.toString(transform),
    transition: isDragging ? 'none' : transition,
    zIndex: isDragging ? 9999 : 'auto',
    // Fix shadow issue when dragging, need to forward the shadow to the parent element to handle the correct radius and blur.
    boxShadow: isDragging ? '0 20px 40px rgba(0, 0, 0, 0.3), 0 0 0 0 rgba(0, 0, 0, 0.1)' : 'none',
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
};
